import { formatPercentage } from "@goodfill/format-number";
import Decimal from "decimal.js";
import React from "react";

export const TransactionRateUpfrontComponent = (props: { value: Decimal }) => {
  return (
    <>
      {formatPercentage({
        value: props.value.toNumber(),
        numDecimals: 2,
      })}
    </>
  );
};
